import { UserRole } from "../User/types"

export type AuthContextProps = {
  isAuthenticated: boolean
  hasLoginError: Error | null
  authUser: AuthUser
  translateUserRole: (role: UserRole) => JSX.Element
  login: (email: string, password: string) => void
  logout: () => void
}

export type AuthProviderProps = {
  isAuthenticated: boolean
  hasLoginError: Error | null
  login: (username: string, password: string) => void
  logout: () => void
  children: React.ReactNode
}

export type LoginResponse = {
  token: string
} & AuthUser

export type AuthUser = {
  id: number
  firstName: string
  lastName: string
  email: string
  role: UserRole
  profilePicture: string
}

export enum LoginError { // need to match the camelCase equivalent of id's in the language files, i.e. login.error.invalidUserNameOrPassword
  INVALID_USERNAME_OR_PASSWORD = 'Invalid username or password',
  NO_CONNECTION = 'No connection',
  UNKNOWN_ERROR = 'Unknown error',
  SESSION_EXPIRED = 'Session expired',
}